'use strict';

module.exports = {
  productKeyDisplayOption: 'productKeyDisplayOption',
  clientProductKeyOption: 'clientProductKeyOption',
  hierarchyOption: 'hierarchyOption',
  storegroupOption: 'storegroupOption',
  chainOption: 'chainOption',
  wholesaleHierarchyOption: 'wholesaleHierarchyOption',
  attributeOption: 'attributeOption',
  attributeDescriptionOption: 'attributeDescriptionOption',
  similarityGroupOption: 'similarityGroupOption',
  cannGroupOption: 'cannGroupOption',
};
